import { showShareModal } from "components/share-modal"
// import Toast from "components/toast"
import "./forecast-user-control.scss"

export default function setListeners() {
  const shareButtonsDesktop = document.querySelectorAll("[data-share-desktop]")
  const shareButtonsMobile = document.querySelectorAll("[data-share-mobile]")

  const shareData = {
    title: document.title,
    text: document.querySelector<HTMLMetaElement>('meta[name="description"]')?.content ?? "",
    url: window.location.href,
  }

  shareButtonsDesktop.forEach((button) => {
    button.addEventListener("click", () => showShareModal())
  })

  shareButtonsMobile.forEach((button) => {
    button.addEventListener("click", async () => {
      try {
        await navigator.share(shareData)
      } catch (error) {
        console.error(error) // eslint-disable-line no-console
        // Toast.generator({
        //   text: "Failed to share",
        //   duration: 3000,
        //   gravity: "bottom",
        //   velocity: 0.1,
        //   position: "center",
        //   color: "#ca0000",
        //   backgroundColor: "#ffdede",
        //   offset: { x: 0, y: 0 },
        // })
      }
    })
  })
}
